<template>
  <v-dialog v-model="modalOpen" max-width="290">
    <v-card>
      <v-card-title class="headline">Atualização</v-card-title>
      <v-card-text>
        Uma nova atualização do sistema está disponível.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" text @click="reloadPage()">
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'updateSystemModal',
  data: () => ({
    modalOpen: false
  }),
  computed: {
    ...mapGetters(['updatSystemModalOpen'])
  },
  watch: {
    updatSystemModalOpen (val) {
      this.modalOpen = val
    },
    modalOpen (val) {
      this.SET_UPDATE_SYSTEM_MODAL(val)
    }
  },
  methods: {
    reloadPage () {
      window.location.reload(true)
    }
  }
}
</script>
